import React, { useCallback } from "react";
import styled from "styled-components";
import { useWallet } from "use-wallet";
import { useTranslation } from "react-i18next";

import Button from "../../Button";
import CardIcon from "../../CardIcon";
import Label from "../../Label";
import Modal, { ModalProps } from "../../Modal";
import ModalActions from "../../ModalActions";
import ModalContent from "../../ModalContent";
import ModalTitle from "../../ModalTitle";
import Spacer from "../../Spacer";
import Value from "../../Value";
import useTokenBalance from "../../../hooks/useTokenBalance";
import { networkID, contractAddresses } from "../../../constants";
import { getBalanceNumber } from "../../../utils/formatBalance";
import snpicon from "../../../assets/images/snp.png";

const StyledAccount = styled.div`
  display: flex;
  color: ${(props) => props.theme.color.grey[800]};
  font-size: 16px;
  font-weight: 600;
  align-items: center;
  justify-content: center;
`;

const StyledBalance = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const StyledBalanceWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-bottom: ${(props) => props.theme.spacing[4]}px;
`;

const AccountModal: React.FC<ModalProps> = ({ onDismiss }) => {
  const { account, reset } = useWallet();
  const snpBalance = useTokenBalance(contractAddresses.snp[networkID]);

  const handleSignOutClick = useCallback(() => {
    onDismiss!();
    reset();
  }, [onDismiss, reset]);

  const { t } = useTranslation();

  return (
    <Modal>
      <ModalTitle text={t("My Account")} />
      <ModalContent>
        <StyledAccount>{account}</StyledAccount>
        <Spacer />
        <div style={{ display: "flex" }}>
          <StyledBalanceWrapper>
            <CardIcon>
              <img src={snpicon} style={{ height: 50 }} />
            </CardIcon>
            <StyledBalance>
              <Value
                value={getBalanceNumber(snpBalance)}
                size="lg"
                decimals={6}
              />
              <Label text={t("SNP Balance")} />
            </StyledBalance>
          </StyledBalanceWrapper>
        </div>

        <Spacer />
        <Button
          onClick={handleSignOutClick}
          text={t("Sign out")}
          variant="secondary"
        />
      </ModalContent>
      <ModalActions>
        <Button onClick={onDismiss} text={t("Cancel")} />
      </ModalActions>
    </Modal>
  );
};

export default AccountModal;
